import { useParams } from 'react-router-dom'
import { useEffectOnce } from 'react-use'

import PageLoading from '~/components/common/PageLoading'
import useAuth from '~/hooks/useAuth'
import ErrorLayout from '~/layouts/ErrorLayout'

const Auth = () => {
  const { token } = useParams()
  const { doLogin, isLoading } = useAuth()

  useEffectOnce(() => {
    doLogin(token as string)
  })

  return (
    <ErrorLayout>
      <PageLoading>{isLoading ? 'Validasi sesi login...' : 'Mengarahkan...'}</PageLoading>
    </ErrorLayout>
  )
}

export default Auth
